import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, fmtDate, formatError } from "@/lib/api";
import { PageHeader, Card } from "@/pages/AppLayout";

export default function Published() {
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get("/projects", { params: { published: true } }).then((r) => setItems(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const url = (slug) => `${window.location.origin}/p/${slug}`;

  const unpublish = async (id) => {
    try { await api.post(`/projects/${id}/unpublish`); toast.success("Aplicación despublicada"); load(); } catch (e) { toast.error(formatError(e)); }
  };

  return (
    <div data-testid="published-page">
      <PageHeader eyebrow="Publicación" title="Aplicaciones publicadas" subtitle="Comparte el enlace público de tus apps. Cada visitante guarda sus propios datos en su navegador." />
      {items?.length === 0 && <Card className="text-center py-14 border-dashed text-slate-400" data-testid="published-empty">Aún no has publicado ninguna aplicación. Ábrela en el constructor y pulsa «Publicar».</Card>}
      <div className="space-y-3">
        {items?.map((p) => (
          <Card key={p.id} className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-testid={`published-item-${p.id}`}>
            <div className="min-w-0">
              <Link to={`/app/proyecto/${p.id}`} className="text-white font-medium hover:text-cyan-300">{p.name}</Link>
              <p className="font-mono text-xs text-cyan-400/80 truncate mt-1">{url(p.slug)}</p>
              <p className="text-xs text-slate-500 mt-1">Versión publicada v{p.published_version} · {fmtDate(p.published_at)}</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => { navigator.clipboard.writeText(url(p.slug)); toast.success("Enlace copiado"); }} data-testid={`published-copy-${p.id}`} className="px-3 py-2 rounded-lg border border-[#222B40] text-slate-300 hover:text-white text-sm inline-flex items-center gap-2"><Copy className="w-4 h-4" />Copiar</button>
              <a href={`/p/${p.slug}`} target="_blank" rel="noreferrer" data-testid={`published-open-${p.id}`} className="px-3 py-2 rounded-lg border border-[#222B40] text-slate-300 hover:text-white text-sm inline-flex items-center gap-2"><ExternalLink className="w-4 h-4" />Abrir</a>
              <button onClick={() => unpublish(p.id)} data-testid={`published-unpublish-${p.id}`} className="px-3 py-2 rounded-lg border border-red-500/30 text-red-300 hover:bg-red-500/10 text-sm">Despublicar</button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
